<template>
  <div id="role">
    <div class="left">
      <div class="head">
        <h3>用户组列表</h3>
        <el-button link icon="Plus" @click="dialogVisible = true"></el-button>
      </div>

      <div
        :class="'item' + (userIndex == index ? ' index' : '')"
        v-for="(item, index) in userList"
        :key="item.id"
        @click="userIndex = index"
      >
        <span>{{ item.name }}</span>
        <el-icon @click="del(item.level)"><Delete /></el-icon>
      </div>
    </div>
    <div class="right">
      <!-- 创建用户组弹窗 -->
      <el-dialog
        v-model="dialogVisible"
        title="创建用户组"
        :width="$store.state.screenWidth > 1200 ? '450px' : '98%'"
        align-center
        @closed="dialogClosed"
        :close-on-click-modal="false"
      >
        <el-form :model="form" ref="formRef" label-position="top">
          <el-form-item
            label="用户组名"
            label-width="85px"
            prop="name"
            :rules="[
              {
                required: true,
                message: '名称不能为空',
                trigger: 'change',
              },
            ]"
          >
            <el-input v-model="form.name" autocomplete="off" />
          </el-form-item>

          <el-form-item label="用户组颜色" label-width="85px">
            <div class="colorBox">
              <div
                class="item"
                v-for="(item, index) in colorList"
                :key="index"
                :style="'background-color:' + item.color + ';'"
                @click="form.color = item.id"
              >
                <el-icon v-show="item.id == form.color"><Select /></el-icon>
              </div>
            </div>
          </el-form-item>

          <el-form-item
            label="用户组级别"
            label-width="85px"
            prop="level"
            :rules="[
              {
                required: true,
                message: '请选择用户组级别',
                trigger: 'change',
              },
            ]"
          >
            <el-select v-model="form.level" placeholder="请选择用户组级别">
              <el-option
                v-for="item in levelData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="用户组排序" label-width="85px">
            <el-input-number
              v-model="form.sort"
              :min="0"
              style="line-height: 1"
            />
          </el-form-item>

          <el-form-item label="用户组备注" label-width="85px">
            <el-input
              v-model="form.remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              type="textarea"
              maxlength="30"
              show-word-limit
              placeholder="请输入用户组备注"
            />
          </el-form-item>

          <div class="state" style="width: 100%">
            <span class="title" style="font-weight: 500">开启用户组</span>
            <el-switch
              v-model="form.state"
              :active-value="1"
              :inactive-value="0"
            />
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="create">创建</el-button>
          </span>
        </template>
      </el-dialog>

      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="info"></el-tab-pane>
        <el-tab-pane label="菜单权限" name="menu"></el-tab-pane>
        <el-tab-pane label="功能权限" name="permissions"></el-tab-pane>
      </el-tabs>

      <transition name="switch" mode="out-in">
        <!-- 基本信息 -->
        <div class="role_body" key="info" v-if="activeName == 'info'">
          <div class="item">
            <div class="title">用户组名</div>
            <el-input v-model="userInfo.name" placeholder="请输入用户组名" />
          </div>

          <div class="item">
            <div class="title">用户组颜色</div>
            <div class="colorBox">
              <div
                class="item"
                v-for="(item, index) in colorList"
                :key="index"
                :style="'background-color:' + item.color + ';'"
                @click="userInfo.color = item.id"
              >
                <el-icon v-show="item.id == userInfo.color"><Select /></el-icon>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="title">用户组级别</div>
            <el-select
              v-model="userInfo.level"
              placeholder="请选择用户组级别"
              disabled
            >
              <el-option
                v-for="item in levelData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <div class="item">
            <div class="title">用户组排序</div>
            <el-input-number v-model="userInfo.sort" :min="0" />
          </div>

          <div class="item">
            <div class="title">用户组备注</div>
            <el-input
              v-model="userInfo.remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              type="textarea"
              maxlength="30"
              show-word-limit
              placeholder="请输入用户组备注"
            />
          </div>

          <div class="state">
            <span class="title">开启用户组</span>
            <el-switch
              v-model="userInfo.state"
              :active-value="1"
              :inactive-value="0"
            />
          </div>

          <div class="bottom">
            <el-button type="primary" @click="save">保存设置</el-button>
            <el-button
              plain
              type="danger"
              icon="Delete"
              @click="del(userInfo.level)"
              >删除用户组</el-button
            >
          </div>
        </div>
        <!-- 功能权限 -->
        <div
          class="role_body"
          key="permissions"
          v-else-if="activeName == 'permissions'"
        >
          <el-empty
            v-if="permissionsData.length == 0"
            :image="require('@/assets/images/empty.png')"
            description="暂无权限可以分配"
            style="--el-empty-padding: 120px 0"
          ></el-empty>
          <template v-else>
            <div class="checkItem">
              <el-checkbox
                v-model="permissionsAll"
                label="全选"
                :indeterminate="checkAllState(permissionsData, '*')"
                @change="checkChange(permissionsData, '*', permissionsAll)"
              />
            </div>
            <template v-for="(item, index) in permissionsData" :key="item.id">
              <div class="checkItem">
                <el-checkbox
                  v-model="item.checked"
                  :label="item.name"
                  :indeterminate="checkAllState(permissionsData, index)"
                  @change="checkChange(permissionsData, item.id, item.checked)"
                />
              </div>
              <div class="checkBox">
                <el-checkbox
                  v-model="item2.checked"
                  :label="item2.name"
                  v-for="item2 in item.children"
                  :key="item2.id"
                  @change="
                    checkChange(permissionsData, item2.id, item2.checked)
                  "
                />
              </div>
            </template>
            <div>
              <el-button type="primary" size="large" @click="save"
                >保存设置</el-button
              >
            </div>
          </template>
        </div>
        <!-- 菜单权限 -->
        <div class="role_body" key="menu" v-else-if="activeName == 'menu'">
          <el-empty
            v-if="pagesData.length == 0"
            :image="require('@/assets/images/empty.png')"
            description="暂无权限可以分配"
            style="--el-empty-padding: 120px 0"
          ></el-empty>
          <template v-else>
            <div class="checkItem">
              <el-checkbox
                v-model="pagesAll"
                label="全选"
                :indeterminate="checkAllState(pagesData, '*')"
                @change="checkChange(pagesData, '*', pagesAll)"
              />
            </div>
            <template v-for="(item, index) in pagesData" :key="index">
              <div class="checkItem">
                <el-checkbox
                  v-model="item.checked"
                  :label="item.name"
                  :indeterminate="checkAllState(pagesData, index)"
                  @change="checkChange(pagesData, item.id, item.checked)"
                />
              </div>
              <div class="checkBox">
                <el-checkbox
                  v-model="item2.checked"
                  :label="item2.name"
                  v-for="(item2, index2) in item.children || []"
                  :key="index2"
                  @change="checkChange(pagesData, item2.id, item2.checked)"
                />
              </div>
            </template>
            <div>
              <el-button type="primary" size="large" @click="save"
                >保存设置</el-button
              >
            </div>
          </template>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  onMounted,
  getCurrentInstance,
  ref,
  computed,
  watch,
  onActivated,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
export default {
  name: "role",
  setup() {
    let vuex = useStore();
    //获取公共方法
    let { proxy } = getCurrentInstance();
    let data = reactive({
      activeName: "info",
      //用户组列表数据
      userList: [],
      //选中用户组下标
      userIndex: 0,
      //选中用户组信息
      userInfo: {},
      //颜色数据
      colorList: [
        {
          id: 1,
          color: "#059669",
        },
        {
          id: 2,
          color: "#34D399",
        },
        {
          id: 3,
          color: "#2FD0DA",
        },
        {
          id: 4,
          color: "#8B5DF1",
        },
        {
          id: 5,
          color: "#FF6DAB",
        },
        {
          id: 6,
          color: "#FB3030",
        },
        {
          id: 7,
          color: "#FFB200",
        },
        {
          id: 8,
          color: "#FC8A32",
        },
        {
          id: 9,
          color: "#77829A",
        },
      ],
      //用户组级别数据
      options: [
        {
          value: 10,
          label: "一级用户",
        },
        {
          value: 20,
          label: "二级用户",
        },
        {
          value: 30,
          label: "三级用户",
        },
        {
          value: 40,
          label: "四级用户",
        },
        {
          value: 50,
          label: "五级用户",
        },
        {
          value: 60,
          label: "六级用户",
        },
        {
          value: 70,
          label: "七级用户",
        },
        {
          value: 80,
          label: "八级用户",
        },
        {
          value: 90,
          label: "九级用户",
        },
      ],
      //弹窗显示状态
      dialogVisible: false,
      //新增相册表单数据
      form: {
        name: "",
        color: "",
        level: 10,
        remark: "",
        state: 1,
        sort: 0,
      },
      formRef: ref(null),
      //权限数据
      permissionsData: [],
      //权限全选
      permissionsAll: true,
      //菜单权限设置
      pagesData: [
        {
          id: 1,
          name: "账号",
          path: "account",
          children: [
            {
              id: 101,
              name: "用户组管理",
              path: "role",
            },
            {
              id: 102,
              name: "用户管理",
              path: "member",
            },
          ],
        },
        {
          id: 2,
          name: "门店",
          path: "home",
          children: [
            {
              id: 201,
              name: "门店类型",
              path: "hotelType",
            },
            {
              id: 202,
              name: "门店列表",
              path: "hotelList",
            },
          ],
        },
        {
          id: 3,
          name: "洗衣机",
          path: "washingMachine",
          children: [
            {
              id: 301,
              name: "厂商配置",
              path: "washingMachineSetting",
            },
            {
              id: 302,
              name: "设备管理",
              path: "washingMachineList",
            },
          ],
        },
        {
          id: 4,
          name: "日志",
          path: "logs",
          children: [
            {
              id: 401,
              name: "登录日志",
              path: "entryLog",
            },
            {
              id: 402,
              name: "操作日志",
              path: "operationLog",
            },
          ],
        },
      ],
      pagesAll: true,
    });

    //级别数据
    let levelData = computed(() => {
      if (vuex.state.pages && vuex.state.pages.level) {
        return data.options.filter(
          (item) => item.value < vuex.state.pages.level
        );
      } else {
        return data.options;
      }
    });

    //监听用户组下标变化
    watch(
      () => data.userIndex,
      (newValue, oldValue) => {
        userFilter();
      }
    );

    //监听功能权限变化
    watch(
      () => data.permissionsData,
      (newValue, oldValue) => {
        data.permissionsAll = newValue.every((item) => {
          return item.checked;
        });
      },
      { deep: true }
    );

    //监听菜单权限变化
    watch(
      () => data.pagesData,
      (newValue, oldValue) => {
        data.pagesAll = newValue.every((item) => {
          return item.checked;
        });
      },
      { deep: true }
    );

    //页面渲染后
    onActivated(() => {
      data.form.level =
        vuex.state.userInfo.level - 10 ? vuex.state.userInfo.level - 10 : "";
      data.pagesData = pagesFilter(data.pagesData, vuex.state.userInfo.pages);
      groupGet();
      permissionsGet();
    });
    //用户组过滤
    let userFilter = () => {
      data.userInfo = JSON.parse(
        JSON.stringify(
          data.userList.find((item, index) => {
            return index == data.userIndex;
          })
        )
      );
      //功能权限
      let grants = data.userList[data.userIndex].grants;
      data.permissionsAll = grants == "*" ? true : false;
      data.permissionsData = checkFilter(data.permissionsData, grants);
      //菜单权限
      let pages = data.userList[data.userIndex].pages;
      data.pagesAll = pages == "*" ? true : false;
      data.pagesData = checkFilter(data.pagesData, pages);
    };
    //菜单权限过滤
    let pagesFilter = (list, pages) => {
      if (pages == "*") {
        return list;
      } else {
        pages = pages.split(",");
      }
      list.forEach((item) => {
        if (item.children) {
          item.children = item.children.filter((item2) => {
            return pages.find((item3) => item3 == item2.id);
          });
        }
      });
      list = list.filter((item) => {
        return item.children.length != 0;
      });
      return list;
    };
    //获取权限用户组
    let groupGet = () => {
      //获取所在门店权限接口
      proxy.$http
        .get("webapi/group_mgr", {
          params: {
            hotel_id: vuex.state.id,
            item: "list",
            orderby: "sort|1,id|0",
            all: 1,
          },
        })
        .then(({ data: res }) => {
          data.userList = res.data.list;
          if (data.userList.length != 0) {
            if (res.data.list.length <= data.userIndex) {
              data.userIndex = 0;
            }
            userFilter();
          }
        })
        .catch((err) => {
          console.log("请求失败", err);
        });
    };
    //获取权限接口
    let permissionsGet = () => {
      proxy.$http
        .get("webapi/group_mgr", {
          params: {
            item: "grants",
          },
        })
        .then(({ data: res }) => {
          if (data.userList[data.userIndex]) {
            let grants = data.userList[data.userIndex].grants;
            data.permissionsData = checkFilter(res.data, grants);
            let pages = data.userList[data.userIndex].pages;
            data.pagesData = checkFilter(data.pagesData, pages);
          } else {
            data.permissionsData = checkFilter(res.data, false);
            data.pagesData = checkFilter(data.pagesData, false);
          }
        })
        .catch((err) => {
          console.log(err, "请求失败");
        });
    };
    //权限过滤
    let checkFilter = (data, checked) => {
      data.forEach((item) => {
        if (checked == "*") {
          item.checked = true;
        } else if (checked) {
          item.checked =
            checked.split(",").findIndex((item2) => item2 == item.id) != -1;
        } else {
          item.checked = false;
        }
        if (item.children) {
          checkFilter(item.children, checked);
        }
      });
      return filterState(data);
    };
    //选中状态过滤
    let filterState = (data) => {
      data.forEach((item) => {
        if (item.children) {
          item.checked = item.children.every((item) => item.checked);
          filterState(item.children);
        }
      });
      return data;
    };
    //全选状态
    let checkAllState = (data, index) => {
      let max = 0;
      let sum = 0;
      if (index == "*") {
        max = checkNum(data);
        sum = checkNum(data, true);
      } else {
        max = checkNum(data[index].children);
        sum = checkNum(data[index].children, true);
      }
      return sum > 0 && sum < max;
    };
    //全选总数
    let checkNum = (data, state = "*") => {
      return data.reduce((num, item) => {
        if (item.children) {
          num += checkNum(item.children, state);
        } else if (state == "*") {
          num++;
        } else if (state == item.checked) {
          num++;
        }
        return num;
      }, 0);
    };
    //权限选中事件
    let checkChange = (data, id, state) => {
      data.forEach((item) => {
        if (id == "*") {
          item.checked = state;
        }
        if (id == "*" || item.id == id) {
          if (item.children) {
            checkChange(item.children, "*", state);
          } else {
            item.checked = state;
          }
        } else {
          if (item.children) {
            checkChange(item.children, id, state);
          }
        }
      });
      filterState(data);
    };
    //保存功能权限配置
    let save = () => {
      console.log(data.userInfo);
      if (!data.userInfo.level) {
        ElMessage({
          message: "请选择用户组！",
          type: "warning",
        });
        return false;
      }
      if (!data.userInfo.name) {
        ElMessage({
          message: "用户组名不能为空！",
          type: "warning",
        });
        return false;
      }
      let grants = [];
      if (data.permissionsAll) {
        grants = "*";
      } else {
        data.permissionsData.forEach((item) => {
          item.children.forEach((item2) => {
            if (item2.checked) {
              grants.push(item2.id);
            }
          });
        });
        grants = grants.join(",");
      }
      let pages = [];
      if (data.pagesAll) {
        pages = "*";
      } else {
        data.pagesData.forEach((item) => {
          item.children.forEach((item2) => {
            if (item2.checked) {
              pages.push(item2.id);
            }
          });
        });
        pages = pages.join(",");
      }
      proxy.$http
        .post("webapi/group_mgr", {
          hotel_id: vuex.state.id,
          item: "set",
          ...data.userInfo,
          grants,
          pages,
        })
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: "保存成功！",
              type: "success",
            });
            groupGet();
          } else {
            ElMessage({
              message: "保存失败！",
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    };
    //弹窗关闭回调
    let dialogClosed = () => {
      data.form = {
        name: "",
        color: "",
        level: 10,
        remark: "",
        state: 1,
        sort: 0,
      };
      data.formRef.resetFields();
    };
    //创建用户组确定事件
    let create = () => {
      data.formRef.validate((valid) => {
        if (valid) {
          proxy.$http
            .post("webapi/group_mgr", {
              hotel_id: vuex.state.id,
              ...data.form,
              color: data.form.color || undefined,
              item: "add",
            })
            .then(({ data: res }) => {
              if (res.code == 0) {
                ElMessage({
                  message: `创建成功！`,
                  type: "success",
                });
              } else {
                ElMessage({
                  message: `创建失败！`,
                  type: "error",
                });
              }
              data.dialogVisible = false;
              groupGet();
            })
            .catch((err) => {
              console.log("创建失败");
            });
        } else {
          return false;
        }
      });
    };
    //删除改用户组
    let del = (level) => {
      ElMessageBox.confirm("此操作将永久删除该用户组, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          proxy.$http
            .post("webapi/group_mgr", {
              level,
              hotel_id: vuex.state.id,
              item: "del",
            })
            .then(({ data: res }) => {
              if (res.code == 0) {
                ElMessage({
                  message: "删除成功！",
                  type: "success",
                });
                groupGet();
              } else {
                ElMessage({
                  message: "删除失败！",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log("删除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    };

    //用户权限状态
    let grantsState = (permissions) => {
      let grants = vuex.state.pages.grants;
      if (grants == "*") {
        return true;
      } else {
        grants = grants.split(",");
        return grants.find((item) => item == permissions);
      }
    };

    return {
      ...toRefs(data),
      save,
      dialogClosed,
      create,
      levelData,
      del,
      checkAllState,
      checkChange,
      grantsState,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/hotel/role.scss";
</style>